import { TextColors } from '@picsart/design-system/foundation/colors';
import { TypographyT6 } from '@picsart/design-system/foundation/typography';

import { useCallback, useMemo, useState } from 'react';

import {
  Button,
  ButtonSizeSM,
  ButtonSkinSecondary,
  ButtonVariants,
} from '@picsart/design-system/components/Button';
import { Text, TextElementTypes } from '@picsart/design-system/components/Text';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

import {
  ANALYTICS_NAMES,
  relevantCategoriesText,
  seeLessText,
  seeMoreText,
} from 'templates/components/SingleTemplate/constants';
import findPosterURL from 'templates/components/SingleTemplate/utils/findPosterURL';

import { useTranslator } from '@picsart/rc/services/localization';

import useStyles from './style';

import { RelevantCategoriesProps } from './types';

const RelevantCategories = ({ categories }: RelevantCategoriesProps) => {
  const classes = useStyles();
  const translate = useTranslator();
  const [expandedCategories, setExpandedCategories] = useState(false);

  const handleExpandedCategoriesClick = useCallback(() => {
    setExpandedCategories(!expandedCategories);
  }, [expandedCategories]);

  const navigateToCategory = useCallback(category => {
    const URL = findPosterURL(category);
    window.open(URL, '_blank');
  }, []);

  const filteredCategoriesLength = useMemo(
    () =>
      categories?.classes?.some(item => item.toLowerCase() !== 'undefined') ||
      categories?.subtypes?.some(item => item.toLowerCase() !== 'undefined'),
    [categories],
  );

  const renderCategoryButtons = (categoryArray: Array<string>) => {
    const arrayToShow = expandedCategories
      ? categoryArray
      : categoryArray.slice(0, 10).filter(item => item.toLowerCase() !== 'undefined');
    return arrayToShow.map((category: string, i: number) => (
      <Button
        variant={ButtonVariants.Outline}
        skin={ButtonSkinSecondary}
        size={ButtonSizeSM}
        key={`${category}--${i}`}
        onClick={() => navigateToCategory(category)}
        className={classes.relevantCategoriesButton}
        data-pulse-name={ANALYTICS_NAMES.RELEVANT_CATEGORY_BUTTON}
      >
        {category.replace('-', ' ')}
      </Button>
    ));
  };
  return (
    Boolean(filteredCategoriesLength) && (
      <div className={classes.categories}>
        <Text
          elementType={TextElementTypes.H2}
          size={TypographyT6}
          weight={FontWeights.semibold}
          color={TextColors.base}
        >
          {translate(relevantCategoriesText)}
        </Text>
        <div className={classes.textContainer}>
          {categories.classes && renderCategoryButtons(categories.classes)}
          {categories.subtypes && renderCategoryButtons(categories.subtypes)}
          {(categories.subtypes?.length > 10 || categories.classes?.length > 10) && (
            <Button
              className={classes.seeButton}
              variant={ButtonVariants.Text}
              onClick={handleExpandedCategoriesClick}
              data-pulse-name={ANALYTICS_NAMES.RELEVANT_CATEGORIES_SEE_BUTTON}
            >
              {translate(expandedCategories ? seeLessText : seeMoreText)}
            </Button>
          )}
        </div>
      </div>
    )
  );
};
export default RelevantCategories;
